import { Component, Injectable } from '@angular/core';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root'
})
export class DialogLauncherService {

  constructor(private dialogService: DialogService) {}

  openDialog(component:any, data: any, width:string, height:string): DynamicDialogRef {
    const dialogRef = this.dialogService.open(component, {
      width: width,
      height: height,
      modal: true,
      dismissableMask: true, //enable closing the dialog on outside click
      focusOnShow: true, // Disable PrimeNG's focus management 
      closable: true,
      showHeader: true,
      autoZIndex: true,
      baseZIndex: 10000,
      focusTrap: true, // Ensure focus is trapped within the dialog
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      data: data
    });

    setTimeout(() => {
      const closeButton = document.querySelector('.p-dialog .p-dialog-header .p-dialog-header-icon') as HTMLElement;
      if (closeButton) {
        closeButton.focus();
      }
    }, 100);

    return dialogRef;
  }
}
